import React from 'react';
import { ScrollView, View } from 'react-native';
import { styles } from './Scaffold.styles';
import { PageLoader } from '../page-loader/PageLoader';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import HeaderWrapper from '../headers/header/HeaderWrapper';
import { PrivacyPolicyCtaDesktop } from '../privacy-policy-cta/PrivacyPolicyCtaDesktop';
import { TestIDs } from 'src/constants/testIDs.constants';

type ScaffoldProps = {
  showHeader: boolean;
  showLoader?: boolean;
  showLoaderSentence?: boolean;
  children?: React.ReactNode;
};
const Scaffold = observer(({ showHeader, showLoader = false, showLoaderSentence = false, children }: ScaffoldProps) => {
  const { isMobile } = useResponsiveScreen();
  const { project } = useStore();

  const ScaffoldContent = isMobile ? ScrollView : View;

  return (
    <View style={styles.container} testID={TestIDs.SCAFFOLD}>
      {showLoader ? (
        <PageLoader showSentence={showLoaderSentence || true} />
      ) : (
        <View style={{ flexShrink: isMobile ? 1 : 0, ...styles.contentWrapper }}>
          {showHeader && project && (
            <HeaderWrapper isMobile={isMobile} isPreviewModeActive={project.isPreviewModeActive} />
          )}
          <ScaffoldContent
            style={styles.content}
            testID={TestIDs.SCAFFOLD_CONTENT}
            contentContainerStyle={{ flex: 1 }}
          >
            {children}
          </ScaffoldContent>
          {!isMobile && <PrivacyPolicyCtaDesktop />}
        </View>
      )}
    </View>
  );
});

export default Scaffold;
